import { render } from "./BlStandaloneSortableItem.vue?vue&type=template&id=4d7d8155"
import script from "./BlStandaloneSortableItem.vue?vue&type=script&lang=js"
export * from "./BlStandaloneSortableItem.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/3a52593b-0c57-4976-8665-ec4c8a4d9b76/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__